import React, { useContext, useEffect } from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Typography } from '@airbus/components-react/components'
import tools from 'utils/helpers'
import PageHeader from 'components/pageHeader'
import LangContext from 'context/LangContext'
import useQuery from 'utils/hooks/useQuery'

type Props = {
  title: string
  documentReference: string
  urlDocument: string
  modalEmbedded: boolean
  onClose: () => void
}

const DocumentPage = ({ title, documentReference, urlDocument, modalEmbedded = false, onClose }: Props) => {
  const baseUrl = process.env.PUBLIC_URL
  const { t } = useTranslation()
  const { lang } = useContext(LangContext)

  const [fileName, setFileName] = useState()
  const { fetchData: fetchDocument } = useQuery(urlDocument)

  /**
   * Extract filename from the response's header
   * @param {*}
   */
  const fetchDocumentWithUrl = async () => {
    const responseDocument = await fetchDocument({
      lang: lang,
    })
    const filenameParts = responseDocument?.headers['content-disposition']
      .split(';')
      .filter((p) => p.includes('filename'))
    if (filenameParts.length > 0) {
      setFileName(filenameParts[0].replace('filename=', '').replaceAll('"', '').replaceAll("'", '').trim())
    }
  }

  useEffect(() => {
    fetchDocumentWithUrl()
  }, [])

  return (
    <>
      <PageHeader
        pageTitle={t('1LEX071') + ' <' + documentReference + '>'}
        modalEmbedded={modalEmbedded}
        modalOnClose={onClose}
      />

      <Container style={{ flex: 1 }} fixed>
        <div>
          {fileName ? <Typography>{t('9510062') + ': ' + fileName}</Typography> : ''}
          <div>
            <embed
              key={'document'}
              title={title}
              src={tools.cleanUrl(baseUrl + '/' + urlDocument)}
              style={{ width: '70vw', height: '100vw' }}
            />
          </div>
        </div>
      </Container>
    </>
  )
}

export default DocumentPage
